<div class="d-flex justify-content-center mt-2">

    <div (click)="onClickTariff()"
        *ngIf="viewTariff()"
        style="cursor: pointer;">
        <div class="d-flex align-items-center " >
            <i class="fa-solid fa-arrow-right fa-2x" title="tariff"></i>
        </div>
    </div>

    <div (click)="onClickHandset()"
        *ngIf="viewHandset()"
        style="cursor: pointer; margin-left: 10%;"
        >
        <div class="d-flex align-items-center ">
            <i class="fa-solid fa-arrow-right fa-2x" title="handset"></i>
        </div>
    </div>





</div>